import React from "react";
import NavBar from "../../components/navBar/NavBar";
import axios from "axios";
import "../../assets/style/style.css";
import swal from "sweetalert";

import load_img from "../../img/big-load.gif";
require("dotenv").config();
const url = process.env.REACT_APP_API_TASK;
class Equipaments extends React.Component {
  state = {
    search: "",
    category: [],
    itens: [],
    itensFilter: [],
    itensAdd: [],
    itensSelecionadosDisplay: "hidden",
    load: false
  };

  componentDidMount() {
    const objForm = {
      id: this.props.match.params.id,
      token: localStorage.getItem("token")
    };

    this.getItens(objForm);
    this.getItensSelecionados(objForm);

    //this.getTecnico(objForm);
  }

  getItensSelecionados = objForm => {
    axios
      .post(
        `${url}/equipamento_selecionado`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        if (response.data.rat[0].status_pedido_equipamento === "concluido") {
          this.setState({
            itensAdd: response.data.equipamento,
            itensSelecionadosDisplay: "show"
            //pedidoRealizado: "concluido"
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
  getItens = objForm => {
    axios
      .post(
        `${url}/equipamento_track`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        //console.log(response);

        this.setState({
          itens: response.data
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleInputChange = e => {
    const key = e.target.id;
    this.setState({ [key]: e.target.value });
  };

  handleInputChangeNumberR = e => {
    let quantEquip = this.refs[e].value;
    const re = /^[0-9\b]+$/;
    if (quantEquip === "" || re.test(quantEquip)) {
      this.refs[e].value = quantEquip;
      this.setState({
        [e]: quantEquip
      });
    }
  };

  filterEquip = e => {
    let arrayItem = this.state.itens;
    let filterBp = this.state.itensFilter;
    //console.log(filterBp);
    if (e.target.value.length) {
      if (e.target.value.length % 3 === 0) {
        let itensFilter = arrayItem.filter((item, i) => {
          return item.short_description
            .toLowerCase()
            .match(e.target.value.toLowerCase());
        });
        if (itensFilter.length) {
          this.setState({ itensFilter });
        } else {
          this.setState({ itensFilter: filterBp });
        }
      }
    } else {
      this.setState({ itensFilter: this.state.itens });
    }
  };

  addItem = e => {
    let quantidade_pedido = this.refs[e.id].value;

    if (!this.refs[e.id].value) {
      quantidade_pedido = 1;
    }
    let obj = {
      short_description: e.short_description,
      quantity: quantidade_pedido,
      id_equip: e.id,
      type: e.type
    };
    this.setState({
      itensAdd: [...this.state.itensAdd, obj]
    });
    this.refs[e.id].value = "";

    swal({
      type: "success",
      title: "Item Adicionado",
      text: e.short_description + " - " + quantidade_pedido,
      showConfirmButton: false,
      timer: 3000,
      icon: "success"
    });
  };

  removerItem = e => {
    let obj = this.state.itensAdd;
    obj.splice(e, 1);
    this.setState({ itensAdd: obj });
    if (obj.length === 0) {
      //this.state.itensSelecionadosDisplay
      this.setState({
        itensSelecionadosDisplay: "hidden"
      });
    }
  };

  showItensSelecionados = () => {
    this.setState({
      itensSelecionadosDisplay: "show"
    });
  };

  closeItensSelecionados = () => {
    this.setState({
      itensSelecionadosDisplay: "hidden"
    });
  };

  postPedidoEquip = () => {
    this.setState({
      load: true
    });
    let obj = this.state.itensAdd;

    let objForm = {
      token: localStorage.getItem("token"),
      objItem: obj,
      id: this.props.match.params.id,
      tecnico: localStorage.getItem("name")
    };

    swal({
      title: "Confirmação de Solicitação de Pedido",

      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        axios
          .post(
            url + "/equipamento_pedido",
            {
              objForm: objForm
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              }
            }
          )
          .then(response => {
            this.setState({
              load: false
            });
            if (response.data.status === 1) {
              //this.setState({ load: false });
              swal("Salvo", " Pedido enviado", "success");
              this.showItensSelecionados();
              this.setState({
                //pedidoRealizado: "concluido"
                itensAdd: response.data.resulLastPedido
              });
            } else {
              swal("Não Salvo", " Ocorreu erro ao Salvar ", "error");
              //this.setState({load:false});
            }

            axios
              .post(
                url + "/postSendEmailEquipamento",
                {
                  objForm: objForm
                },
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                  }
                }
              )
              .then(response => {
                console.log(response);
              })
              .catch(function(error) {
                console.log(error);
              });
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        swal("Confirme seu pedido ao acabar.");
        this.setState({
          load: false
        });
      }
    });
  };

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast={`/task-descriptions/${this.props.match.params.id}`} />
        <div className="container-fluid container_body">
          <div className="containerCard">
            <div className="card marginTop6">
              <h5 className="card-header">Equipamento</h5>
              <div className="card-body">
                <div className="form-group">
                  {this.state.pedidoRealizado !== "concluido" && (
                    <div className="form-group">
                      <label>Buscar Item</label>
                      <input
                        type="text"
                        className="form-control"
                        name="search"
                        id="search"
                        onKeyUp={this.filterEquip}
                      />
                      <small id="emailHelp" className="form-text text-muted">
                        Itens encontrados (
                        {this.state.itensFilter.length > 0 &&
                          this.state.itensFilter.length}
                        {this.state.itensFilter.length === 0 &&
                          this.state.itens.length}
                        )
                      </small>
                    </div>
                  )}
                  <div className="containerItemAdd">
                    <div
                      className={`card-body ${this.state.itensSelecionadosDisplay}`}
                    >
                      {this.state.itensAdd.map((item, i) => (
                        <div className="input-group mb-3" key={i}>
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text centerPadding"
                              id="inputGroup-sizing-default"
                            >
                              {item.quantity}
                            </span>
                          </div>
                          <div className="input-group-prepend">
                            <span
                              className="centerPadding"
                              id="inputGroup-sizing-default"
                              style={shortDescription}
                            >
                              {item.short_description === "AbraÃ§adeira tipo U"
                                ? "Abraçadeira tipo U"
                                : item.short_description}
                            </span>
                          </div>

                          <div className="input-group-prepend">
                            <span
                              className="input-group-text centerPadding"
                              id="inputGroup-sizing-default"
                            >
                              {item.id_equip ? (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.removerItem(i)}
                                >
                                  -
                                </button>
                              ) : (
                                item.liberacao
                              )}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {this.state.load === true && (
                    <center>
                      <img src={load_img} width="100" alt="img" />
                    </center>
                  )}

                  {this.state.itensAdd.length > 0 &&
                    this.state.load === false &&
                    this.state.pedidoRealizado !== "concluido" && (
                      <div className="form-group">
                        {this.state.itensSelecionadosDisplay === "hidden" && (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm mt-1"
                            onClick={() => this.showItensSelecionados()}
                          >
                            Visualizar Selecionados
                          </button>
                        )}

                        {this.state.itensSelecionadosDisplay === "show" && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm marginLeft2 mt-1"
                            onClick={() => this.closeItensSelecionados()}
                          >
                            Fechar Selecionados
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-success btn-sm marginLeft2 mt-1"
                          onClick={() => this.postPedidoEquip()}
                        >
                          Concluir Pedido
                        </button>
                      </div>
                    )}

                  {this.state.pedidoRealizado !== "concluido" && (
                    <label> Equipamentos</label>
                  )}

                  {this.state.pedidoRealizado !== "concluido" &&
                    this.state.itensFilter.map((item, i) => (
                      <div className="card marginTop2" key={item.id}>
                        <div className="card-body">
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span
                                className="input-group-text centerPadding"
                                id="inputGroup-sizing-default"
                              >
                                {item.quantity}
                              </span>
                            </div>
                            <div className="input-group-prepend">
                              <span
                                style={shortDescription}
                                className="input-group-text centerPadding"
                                id="inputGroup-sizing-default"
                              >
                                {item.short_description ===
                                "AbraÃ§adeira tipo U"
                                  ? "Abraçadeira tipo U"
                                  : item.short_description}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Quantidade"
                                ref={item.id}
                                onChange={() =>
                                  this.handleInputChangeNumberR(item.id)
                                }
                                value={this.state[item.id]}
                              />
                            </div>
                            <div className="col">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.addItem(item)}
                              >
                                Adicionar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  {this.state.pedidoRealizado !== "concluido" &&
                    this.state.itensFilter.length === 0 &&
                    this.state.itens.map((item, i) => (
                      <div className="card marginTop2" key={item.id}>
                        <div className="card-body">
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span
                                className="input-group-text centerPadding"
                                id="inputGroup-sizing-default"
                              >
                                {item.quantity}
                              </span>
                            </div>
                            <div className="input-group-prepend">
                              <span
                                className=" centerPadding"
                                id="inputGroup-sizing-default"
                                style={shortDescription}
                              >
                                {item.short_description}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Quantidade"
                                ref={item.id}
                                onChange={() =>
                                  this.handleInputChangeNumberR(item.id)
                                }
                                value={this.state[item.id]}
                              />
                            </div>
                            <div className="col">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.addItem(item)}
                              >
                                Adicionar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Equipaments;

const shortDescription = {
  width: "13em",

  wordWrap: "break-word"
};
